<template>
  <div class="ZoomControls">
    <div>
      <div v-bind:class="panToolClass" v-on:click="setPanTool">
        <img src="/img/icons/move-outline.svg" />
        <div class="CircleShadowButton_HoverText m-left">
          <span>Pan (space)</span>
        </div>
      </div>

      <div
        v-if="isZoomAllowed"
        v-on:click="zoomIn"
        :class="{
          CircleShadowButton: true,
          'm-zoom-in': true,
          'm-disabled': !canZoomIn,
        }"
      >
        <img src="/img/icons/add-outline.svg" />
        <div class="CircleShadowButton_HoverText m-left">
          <span>Zoom in</span>
        </div>
      </div>

      <div
        v-if="isZoomAllowed"
        v-on:click="zoomOut"
        :class="{
          CircleShadowButton: true,
          'm-zoom-out': true,
          'm-disabled': !canZoomOut,
        }"
      >
        <img src="/img/icons/remove-outline.svg" />
        <div class="CircleShadowButton_HoverText m-left">
          <span>Zoom out</span>
        </div>
      </div>

      <div
        v-if="isZoomAllowed"
        v-on:click="reset"
        :class="{
          CircleShadowButton: true,
          'm-reset': true,
          'm-disabled': !canReset,
        }"
      >
        <img src="/img/icons/reorder-two-outline.svg" />
        <div class="CircleShadowButton_HoverText m-left">
          <span>Zoom to 100%</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component } from "vue-property-decorator";
import ToolType from "@/wbcontroller/types/ToolType";
import WBComponent from "@/WBComponent";
import { GlobalMutations } from "@/store/mutations";

@Component
export default class ZoomControls extends WBComponent {
  get isZoomAllowed(): boolean {
    return this.state.reported.zoom.isAllowed;
  }

  get canZoomOut(): boolean {
    return this.state.reported.zoom.scale > this.state.reported.zoom.minScale;
  }

  get canZoomIn(): boolean {
    return this.state.reported.zoom.scale < this.state.reported.zoom.maxScale;
  }

  get canReset(): boolean {
    return this.state.reported.zoom.scale != 1;
  }

  get panToolClass(): string {
    return this.state.hud.tool === ToolType.Pan
      ? "CircleShadowButton m-active "
      : "CircleShadowButton ";
  }

  setPanTool() {
    GlobalMutations.setTool(this.$store.commit, ToolType.Pan);
  }

  zoomOut() {
    let nextLeast = this.state.reported.zoom.scaleSteps[0];
    for (const s of this.state.reported.zoom.scaleSteps) {
      if (s >= this.state.reported.zoom.scale) break;
      nextLeast = s;
    }
    this.$emit("setScale", nextLeast);
  }

  zoomIn() {
    const reversedScales = new Array<number>()
      .concat(this.state.reported.zoom.scaleSteps)
      .reverse();
    let nextGreatest = reversedScales[0];
    for (const s of reversedScales) {
      if (s <= this.state.reported.zoom.scale) break;
      nextGreatest = s;
    }
    this.$emit("setScale", nextGreatest);
  }

  reset() {
    this.$emit("setScale", 1);
  }
}
</script>

<style scoped lang="scss">
.ZoomControls {
  position: fixed;
  right: 5px;
  top: 60px;
  bottom: 100px;
  display: flex;
  justify-content: center;
  flex-direction: column;

  @media (max-height: 540px) {
    justify-content: flex-end;
    bottom: 55px;
  }

  .CircleShadowButton {
    margin: 5px;
  }
}
</style>
